/*
 * Feuille de choix de format du tiroir panier — Épices Moralès.
 *
 * Ouverte depuis une carte de « Ça va bien ensemble ». Trois partis pris :
 *
 * 1. Le contenu vient de l'API de rendu de sections
 *    (/products/<handle>?section_id=cart-format-sheet) et non du JSON des
 *    recommandations. Les badges, le prix au kilo, le sous-titre de variante et
 *    l'accroche vivent dans des metachamps, invisibles depuis
 *    /recommendations/products.json. Les reconstruire en JS aurait donne des
 *    rangees plus pauvres que partout ailleurs sur le site.
 *
 * 2. Le controleur est un singleton pose sur window, pas une methode du
 *    composant <cart-upsell>. Le tiroir remplace tout son contenu a chaque
 *    ajout au panier : un ecouteur pose sur le composant disparaitrait avec
 *    lui. Ici les ecouteurs sont delegues au document, une seule fois.
 *
 * 3. La feuille est posee dans .drawer__inner, en position absolue. Elle
 *    s'arrete donc aux bords du tiroir au lieu de couvrir la page : le tiroir
 *    est deja un panneau pose sur le site, une feuille qui y monte reste
 *    coherente, et le panier reste lisible derriere son voile.
 */

(function () {
  if (window.mlsFeuilleFormat) return;

  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 1025px : le point de rupture du theme, tiroir compris. Au-dessus la souris
     a besoin d'une croix, en dessous le doigt a la poignee et le glisser. */
  function surOrdinateur() {
    return window.matchMedia('(min-width: 1025px)').matches;
  }

  function hote() {
    var panneau = document.querySelector('cart-drawer .drawer__inner');
    if (!panneau) return null;

    var h = panneau.querySelector('.cfs-hote');
    /* La coque est reconstruite si la largeur a franchi le seuil depuis la
       derniere ouverture : une fenetre qu'on redimensionne, un telephone qu'on
       tourne. Sinon elle garderait la croix ou la poignee de l'autre monde. */
    if (h && h.dataset.desk === (surOrdinateur() ? '1' : '0')) return h;
    if (h) h.remove();

    h = document.createElement('div');
    h.className = 'cfs-hote';
    h.dataset.desk = surOrdinateur() ? '1' : '0';
    /* La barre de fermeture appartient a la COQUE, pas au contenu rendu par la
       section : elle doit exister des l'ouverture, pendant que la section se
       charge encore, et rester en place quand le contenu defile. */
    h.innerHTML =
      '<div class="cfs-voile" data-cfs-fermer></div>' +
      '<div class="cfs-panneau" role="dialog" aria-modal="true" aria-label="Choisir un format">' +
        '<div class="cfs-barre">' +
          '<span class="cfs-poignee" data-cfs-fermer aria-hidden="true"></span>' +
          /* Trace exact de snippets/icon-close-small.liquid, celui de la croix
             du tiroir. Recopie et non rendu par Liquid : cette coque est
             construite en JS. Son fill d'origine est un bleu en dur, la CSS le
             force a la couleur du texte comme le fait deja le tiroir. */
          /* La croix n'est PAS rendue sous 1025px, au lieu d'etre masquee par la
             CSS. Un bouton masque reste dans le document : il s'annonce encore
             aux lecteurs d'ecran, et il suffit d'une feuille de style servie
             depuis le cache pour qu'il reapparaisse. Ce qui ne doit pas exister
             ne se construit pas. */
          (surOrdinateur()
            ? '<button type="button" class="cfs-x" data-cfs-fermer aria-label="Fermer">' +
              '<svg viewBox="0 0 12 12" width="15" height="15" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.58586 6.00008L0.292969 1.70718L1.70718 0.292969L6.00008 4.58586L10.293 0.292969L11.7072 1.70718L7.41429 6.00008L11.7072 10.293L10.293 11.7072L6.00008 7.41429L1.70718 11.7072L0.292969 10.293L4.58586 6.00008Z"/></svg>' +
              '</button>'
            : '') +
        '</div>' +
        '<div class="cfs-corps"></div>' +
      '</div>';
    panneau.appendChild(h);
    return h;
  }

  /* Le corps du tiroir ne doit pas defiler derriere la feuille : le geste
     n'agit que dans la feuille, et si son contenu tient en entier, rien ne
     bouge. Meme regle que les feuilles des fiches et des cartes. */
  function verrou(actif) {
    var corps = document.querySelector('cart-drawer cart-drawer-items');
    if (corps) corps.style.overflowY = actif ? 'hidden' : '';
  }

  var ctrl = {
    ouverteA: 0,

    ouvrir: function (handle) {
      if (!handle) return;
      var h = hote();
      if (!h) return;

      var panneau = h.querySelector('.cfs-panneau');
      var corps = h.querySelector('.cfs-corps');
      /* On monte la feuille AVANT d'avoir le contenu : sinon le tap reste sans
         effet le temps de la requete, et on tape une seconde fois. */
      panneau.setAttribute('data-charge', '1');
      corps.innerHTML = '<span class="cfs-attente" aria-hidden="true"></span>';
      h.classList.add('est-ouvert');
      this.ouverteA = Date.now();
      verrou(true);

      fetch(RACINE + 'products/' + encodeURIComponent(handle) + '?section_id=cart-format-sheet')
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          if (!h.classList.contains('est-ouvert')) return;
          panneau.removeAttribute('data-charge');
          corps.innerHTML = html;
          panneau.scrollTop = 0;
        })
        .catch(function () {
          /* Une feuille vide serait un cul-de-sac : on referme et on laisse la
             carte faire ce qu'elle faisait avant, mener a la fiche produit. */
          ctrl.fermer();
          window.location.href = RACINE + 'products/' + encodeURIComponent(handle);
        });
    },

    fermer: function () {
      var h = document.querySelector('cart-drawer .cfs-hote');
      if (!h) return;
      h.classList.remove('est-ouvert');
      verrou(false);
    },

    estOuverte: function () {
      var h = document.querySelector('cart-drawer .cfs-hote');
      return !!(h && h.classList.contains('est-ouvert'));
    },
  };

  /* ------------------------------------------------------------- selection */
  function choisir(rang) {
    var panneau = rang.closest('.cfs-panneau');
    var input = rang.querySelector('.cfs__radio-input');
    if (!panneau || !input || input.disabled) return;

    panneau.querySelectorAll('.cfs__rang').forEach(function (r) { r.classList.remove('est-choisi'); });
    rang.classList.add('est-choisi');
    input.checked = true;

    var atc = panneau.querySelector('[data-cfs-ajouter]');
    if (!atc) return;
    var prix = atc.querySelector('.cfs__atc-prix');
    var ref = atc.querySelector('.cfs__atc-ref');
    if (prix && input.dataset.prix) prix.textContent = input.dataset.prix;
    if (ref) {
      if (input.dataset.compare) {
        ref.textContent = input.dataset.compare;
        ref.hidden = false;
      } else {
        ref.hidden = true;
      }
    }
  }

  /* ---------------------------------------------------------- ajout au panier */
  function ajouter(bouton) {
    var panneau = bouton.closest('.cfs-panneau');
    var choisi = panneau && panneau.querySelector('.cfs__radio-input:checked');
    if (!choisi || bouton.hasAttribute('disabled')) return;

    bouton.classList.add('cta-charge');
    var tiroir = document.querySelector('cart-drawer');
    var sections = tiroir && tiroir.getSectionsToRender
      ? tiroir.getSectionsToRender().map(function (s) { return s.id; })
      : [];

    fetch(RACINE + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(choisi.value), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json().then(function (etat) { return { ok: r.ok, etat: etat }; }); })
      .then(function (res) {
        if (!res.ok) {
          bouton.classList.remove('cta-charge');
          return;
        }
        /* Fermer AVANT le redessin : renderContents remplace tout le contenu du
           tiroir, y compris l'hote de la feuille. Sans cette fermeture le
           verrou de defilement resterait pose sur un element detruit. */
        ctrl.fermer();
        if (tiroir && res.etat.sections) tiroir.renderContents(res.etat);
        else window.location.reload();
      })
      .catch(function () {
        bouton.classList.remove('cta-charge');
      });
  }

  /* ------------------------------------------------------------- ecouteurs */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-cfs-fermer]')) { ctrl.fermer(); return; }
    /* Un clic dans la barre, ailleurs que sur la poignee ou la croix, ne doit
       rien faire : c'est une zone de chrome, pas une sortie. Sans ce retour,
       le clic tombait plus bas sur le test des rangees. */
    if (t.closest('.cfs-barre')) return;

    var atc = t.closest('[data-cfs-ajouter]');
    if (atc) { ajouter(atc); return; }

    var rang = t.closest('.cfs__rang');
    if (rang) { e.preventDefault(); choisir(rang); }
  });

  document.addEventListener('keydown', function (e) {
    /* Echap ferme la feuille AVANT le tiroir : sans stopPropagation, la touche
       fermait les deux d'un coup et on se retrouvait sur la page, panier clos. */
    if (e.key === 'Escape' && ctrl.estOuverte()) {
      e.stopPropagation();
      ctrl.fermer();
    }
  }, true);

  /* Glisser vers le bas, comme les deux autres feuilles du site. Ne s'amorce
     que si la feuille est en haut de son defilement, sinon on volerait le
     defilement interne d'une longue liste de formats. */
  var glisse = null;
  document.addEventListener('touchstart', function (e) {
    var panneau = e.target.closest && e.target.closest('.cfs-panneau');
    if (!panneau || !ctrl.estOuverte() || panneau.scrollTop > 0) return;
    glisse = { p: panneau, y0: e.touches[0].clientY, d: 0, t0: Date.now() };
    panneau.style.transition = 'none';
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (glisse) {
      glisse.d = Math.max(0, e.touches[0].clientY - glisse.y0);
      if (glisse.d > 0 && e.cancelable) e.preventDefault();
      glisse.p.style.transform = 'translateY(' + glisse.d + 'px)';
      return;
    }
    /* Hors du panneau, tant que la feuille est ouverte, le geste ne fait rien :
       ni la feuille ni le tiroir derriere ne doivent bouger. */
    if (!ctrl.estOuverte()) return;
    var dans = e.target.closest && e.target.closest('.cfs-panneau');
    if (!dans && e.cancelable) e.preventDefault();
  }, { passive: false });

  document.addEventListener('touchend', function () {
    if (!glisse) return;
    var g = glisse;
    glisse = null;
    g.p.style.transition = '';
    g.p.style.transform = '';
    var vitesse = g.d / Math.max(1, Date.now() - g.t0);
    if (g.d > 90 || vitesse > 0.5) ctrl.fermer();
  });

  window.mlsFeuilleFormat = ctrl;
})();
